import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QAOffering from "@/pages/QAOffering";

export const Route = createFileRoute("/es/servicios/quality-assurance/implementacion-qms")({
  head: () => buildRouteHead("/es/servicios/quality-assurance/implementacion-qms"),
  component: QAOffering,
});

